import type { ActionTree, GetterTree } from "vuex";
import type { IDataState } from "@/store/modules/data";
import { DataModules } from "@/store/modules/data/modules";
import type { ApiPathGetter } from "@upmind-automation/types";
import type { IState } from "@/store";

/**
 * Client login attempts (IP logging) — FE-506.
 * Admin-only: lists a given client's attempts, identified by an object_id
 * filter. A client's own attempts are served by the `selfLoginAttempts` module.
 */

const initialState = {} as IDataState;

const getters: GetterTree<IDataState, IState> = {
  apiPath: (): ApiPathGetter => () => {
    const admin = "api/admin/clients/login_attempts";
    return { admin };
  }
};

const actions: ActionTree<IDataState, IState> = {
  list: ({ dispatch, getters }, payload) => {
    return dispatch(
      "data/list",
      {
        ...payload,
        path: getters.apiPath().admin,
        params: {
          ...payload?.params,
          // The endpoint is not client-scoped by path, so identify the client
          // via an object_id filter.
          ...(payload?.object_id
            ? { "filter[object_id]": payload.object_id }
            : {})
        },
        splitCount: true,
        storeModule: DataModules.CLIENTS_LOGIN_ATTEMPTS
      },
      { root: true }
    );
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  actions
};
